var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-layout",
    {
      staticClass: "home-container",
      attrs: { id: "components-layout-demo-custom-trigger" },
    },
    [
      _c("Header"),
      _c("div", {}, [
        _c("img", {
          staticStyle: {
            display: "block",
            width: "100%",
            height: "410px",
            margin: "0 auto",
          },
          attrs: { src: _vm.banner },
        }),
        _c("div", { staticClass: "box_title" }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "block",
                width: "1920px",
                "justify-content": "flex-start",
              },
            },
            [
              _c("img", {
                staticStyle: {
                  width: "115px",
                  height: "22.2px",
                  margin: "10px 20px",
                },
                attrs: { src: _vm.selfhelpicon },
              }),
            ]
          ),
        ]),
        _c("div", { staticClass: "box_menu" }, [
          _c(
            "div",
            {
              staticClass: "box_menu_list",
              on: {
                click: function ($event) {
                  return _vm.titleClick(1, 0)
                },
              },
            },
            [
              _c("div", {
                staticClass: "box_menu_list_img_one box_menu_list_img",
              }),
              _c("span", { staticClass: "box_menu_list_title" }, [
                _vm._v("证书订购"),
              ]),
              _c("div", { staticClass: "box_menu_list_tishi" }, [
                _vm._v("轻松订购，安全保障"),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "box_menu_list",
              on: {
                click: function ($event) {
                  return _vm.titleClick(8, 0)
                },
              },
            },
            [
              _c("div", {
                staticClass: "box_menu_list_img_three box_menu_list_img",
              }),
              _c("span", { staticClass: "box_menu_list_title" }, [
                _vm._v("年费服务"),
              ]),
              _c("div", { staticClass: "box_menu_list_tishi" }, [
                _vm._v("尊享服务，快乐无忧"),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "box_menu_list",
              on: {
                click: function ($event) {
                  return _vm.titleClick(6, 0)
                },
              },
            },
            [
              _c("div", {
                staticClass: "box_menu_list_img_four box_menu_list_img",
              }),
              _c("span", { staticClass: "box_menu_list_title" }, [
                _vm._v("证书检测"),
              ]),
              _c("div", { staticClass: "box_menu_list_tishi" }, [
                _vm._v("证书状态，一目了然"),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "box_menu_list",
              on: {
                click: function ($event) {
                  return _vm.titleClick(3, 0)
                },
              },
            },
            [
              _c("div", {
                staticClass: "box_menu_list_img_five box_menu_list_img",
              }),
              _c("span", { staticClass: "box_menu_list_title" }, [
                _vm._v("订单查询"),
              ]),
              _c("div", { staticClass: "box_menu_list_tishi" }, [
                _vm._v("证书订单，一键查询"),
              ]),
            ]
          ),
        ]),
      ]),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }